<template>
  <div>
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <v-container>
      <v-row class="mx-auto">
        <v-col>
          <v-card class="white--text mx-auto my-auto" persistent width="550" height="380" flat>
            <v-card-title primary-title>
              <div>
                <div class="text-h5 primary2--text text--darken-3 mt-5">Cambio de contraseña</div>
                <span class="subtitle-1 secundary--text">
                  Introduce tu correo, el PIN de Usuario y la nueva contraseña
                </span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-form ref="myForm">
                <v-form-base
                  id="form-base-complete"
                  class="d-flex justify-center my-3"
                  v-if="schemaForm && modelForm"
                  :schema="schemaForm"
                  :model="modelForm"
                  @input="log"
                  @click="log"
                  @keyup.enter="enterClicked"
                />
              </v-form>
              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  class="secundary2 white--text mb-5 text-capitalize"
                  @click="reSendCode"
                  disabled
                  v-if="timerActive === true"
                >
                  Reenviar código
                  <span class="text-lowercase">({{ timerCount }} seg.)</span>
                </v-btn>
                <v-btn
                  class="secundary2 white--text mb-5 text-capitalize"
                  @click="reSendCode"
                  v-else
                >
                  Enviar código
                </v-btn>
              </v-col>
              <v-divider></v-divider>
              <div class="mt-6">
                <div class="ma-auto position-relative" style="max-width: 300px">
                  <span class="d-flex text-caption justify-center mb-2">{{ schema.text2 }}</span>
                  <v-otp-input
                    v-model="otp"
                    length="6"
                    :disabled="loading"
                    @finish="onFinish"
                  ></v-otp-input>
                  <v-overlay absolute :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-overlay>
                </div>
                <span class="d-flex justify-center text-caption mt-7">
                  {{ text }}
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import VFormBase from 'vuetify-form-base';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProRePassPage',
  components: {
    MainHeaderInfo,
    VFormBase,
    VSnackBar,
  },
  data() {
    return {
      loading: false,
      otp: '',
      text: '',
      timerActive: false,
      timerCount: 0,
      modelForm: {},
      schemaForm: {
        email: {
          type: 'email',
          label: 'Email',
          outlined: true,
          dense: true,
          flex: {
            "xs": 12,
            "sm": 9
          },
          class: 'mx-2',
        },
        passwordNew: {
          type: 'password',
          label: 'Contraseña Nueva',
          appendIcon: 'mdi-eye',
          clearable: true,
          outlined: true,
          dense: true,
          flex: {
            "xs": 12,
            "sm": 6
          },
          class: 'mx-2',
        },
        pinNew: {
          type: 'text',
          label: 'PIN nuevo',
          hint: '4 dígitos',
          maxlength: '4',
          clearable: true,
          outlined: true,
          dense: true,
          flex: {
            "xs": 12,
            "sm": 3
          },
          class: 'mx-2',
        },
      },
    };
  },

  mounted() {
    this.loadSchema();
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters('proRePassPage', ['schema', 'status']),
    ...mapGetters('notifications', ['snackbar']),
  },

  methods: {
    ...mapActions('proRePassPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async onFinish() {
      this.loading = true;
      let otp = this.otp;
      let model = {};
      model = this.modelForm;
      model.otp = otp;

      this.$store.dispatch('proRePassPage/rePass', { model }).then(
        () => {
          if (this.status === true) {
            this.loading = false;
            this.text = 'Se realizó el cambio de la contraseña y el pin.';
            setTimeout(() => {
              this.$router.push({ name: 'login' });
            }, 4000);
          } else if (this.status === false) {
            this.loading = false;
            this.text = 'Código de verificación es incorrecto';
          }
        },
        () => {
          this.loading = false;
          this.text = 'Código de verificación es incorrecto';
        }
      );
    },

    async reSendCode() {
      this.otp = '';
      this.text = ' ';
      this.timerCount = 30;
      this.timerActive = true;

      setTimeout(() => {
        this.timerActive = false;
        this.timerCount = 0;
      }, 30000);

      let model = {};
      model = this.modelForm;
      model.otp = this.otp;

      this.$store.dispatch('proRePassPage/reSendCode', { model }).then(
        () => {
          if (this.status === true) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Se ha enviado un Código de verificación a tu email';
            }, 1500);
            this.otp = '';
            this.text = '';
          } else if (this.status === false) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
            }, 1500);
          }
        },
        () => {
          setTimeout(() => {
            this.loading = false;
            this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
          }, 1500);
        }
      );
    },

    log(val) {
      let { on, key, obj, params } = val;
      if (
        on === 'click' &&
        key === 'subgroups.content' &&
        (params && params.tag) === 'prepend-inner'
      ) {
        window.print();
      }
      if (on === 'click' && key === 'passwordNew' && (params && params.tag) === 'append') {
        obj.schema.type === 'password'
          ? (obj.schema.appendIcon = 'mdi-eye-off')
          : (obj.schema.appendIcon = 'mdi-eye');
        obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password';
      }
    },
  },
};
</script>

<style>
#form-base-complete .key-subgroups-content {
  background-color: #faf3e9;
  padding: 1rem;
}

#form-base-complete .key-subgroups-tasks {
  background-color: #e2eaf5;
  padding: 1rem;
}

@media print {
  html * {
    position: fixed;
    top: 0;
    bottom: 0;
    visibility: hidden;
  }

  .key-subgroups-content textarea {
    visibility: visible;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .key-subgroups-content textarea * {
    visibility: visible;
  }
}
</style>
